<template>
  <div>
    <!-- Card 1: Informações da Atividade em Saúde -->
    <div class="card card-topo">
    <div class="card-header bg-light font-weight-bold d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <i class="mdi mdi-information mr-2"></i>
        Informações da Atividade
      </div>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="abrirGuia"
        title="Abrir guia de suporte"
        v-if="mostrarGuia"
      >
        <i class="mdi mdi-book-open-variant mr-1"></i>
        Guia
      </button>
    </div>
    <div class="card-body">
        <!-- Linha 1: Data da atividade, Turno, Nº de participantes -->
      <div class="row">
          <div class="col-md-4 col-12 mb-3">
            <label for="data" class="form-label">Data da atividade</label>
            <div class="input-date-wrapper position-relative">
              <input
                id="data"
                type="text"
                class="form-control input-with-icon"
                :value="dataFormatada"
                placeholder="dd/mm/aaaa"
                readonly
              />
              <input
                ref="datePicker"
                type="date"
                class="date-picker-hidden"
                v-model="formData.data"
                disabled
              />
              <i 
                class="mdi mdi-calendar date-icon" 
                title="Selecionar data"
              ></i>
            </div>
            <div v-if="mostrarErros && erros.data" class="text-danger mt-1 small">
              {{ erros.data }}
            </div>
          </div>
          
          <div class="col-md-4 col-12 mb-3">
            <label for="turno" class="form-label">Turno</label>
            <select
              id="turno"
              class="form-select form-control"
              v-model="formData.turno"
              @change="validarTurno"
            >
              <option disabled value="">Selecione o turno</option>
              <option value="1">Manhã</option>
              <option value="2">Tarde</option>
              <option value="3">Noite</option>
            </select>
            <div v-if="mostrarErros && erros.turno" class="text-danger mt-1 small">
              {{ erros.turno }}
            </div>
          </div>

          <div class="col-md-4 col-12 mb-3">
            <label for="numeroParticipantes" class="form-label">N° de participantes</label>
            <input
              id="numeroParticipantes"
              type="number"
              class="form-control"
              v-model.number="formData.numeroParticipantes"
              placeholder="Informe o número"
              :min="isEditMode ? 0 : 1"
              :max="999"
              @input="corrigirNumeroParticipantes"
            />
            <div v-if="mostrarErros && erros.numParticipantes" class="text-danger mt-1 small">
            {{ erros.numParticipantes }}
          </div>
        </div>
      </div>

        <!-- Linha 2: Hora de início, Hora de fim e Carga horária -->
        <div class="row mt-3">
          <div class="col-md-4 col-12 mb-3">
            <label for="horaInicio" class="form-label">Hora de início</label>
              <input
              id="horaInicio"
              type="time"
              class="form-control"
              :class="{ 'is-invalid': mostrarErros && erros.horaInicio }"
              v-model="formData.horaInicio"
              @input="validarHoras"
              @blur="validarHoras"
              />
            <div v-if="mostrarErros && erros.horaInicio" class="text-danger mt-1 small">
              {{ erros.horaInicio }}
            </div>
            </div>

          <div class="col-md-4 col-12 mb-3">
            <label for="horaFim" class="form-label">Hora de fim</label>
              <input
              id="horaFim"
              type="time"
              class="form-control"
              :class="{ 'is-invalid': mostrarErros && erros.horaFim }"
              v-model="formData.horaFim"
              @input="validarHoras"
              @blur="validarHoras"
              />
            <div v-if="mostrarErros && erros.horaFim" class="text-danger mt-1 small">
              {{ erros.horaFim }}
            </div>
          </div>

          <div class="col-md-4 col-12 mb-3">
            <label for="qtdHoras" class="form-label">Carga horária (horas)</label>
            <select
              id="qtdHoras"
              class="form-select form-control"
              v-model="formData.qtdHoras"
            >
              <option disabled value="">Selecione a carga horária</option>
              <option v-for="n in 8" :key="n" :value="n">{{ n }}</option>
            </select>
          </div>
        </div>

        <!-- Linha 3: Forma e Tipo -->
        <div class="row mt-3">
          <div class="col-md-4 col-12 mb-3">
            <label for="forma" class="form-label">Forma</label>
            <select
              id="forma"
              class="form-select form-control"
              :class="{ 'is-invalid': mostrarErros && erros.forma }"
              v-model="formData.forma"
              @change="validarForma"
            >
              <option disabled value="">Selecione a forma</option>
              <option value="presencial">Presencial</option>
              <option value="telepresenca">Telepresença</option>
              <option value="online">100% Online</option>
            </select>
            <div v-if="mostrarErros && erros.forma" class="text-danger mt-1 small">
              {{ erros.forma }}
        </div>
      </div>

          <div class="col-md-8 col-12 mb-3">
            <label for="tipo" class="form-label">Tipo</label>
            <vue-select
              id="tipo"
              v-model="tipoSelecionado"
              :options="tiposDisponiveis"
              label="tp_reun_ofic_treinam"
              placeholder="Selecione o tipo"
              :loading="isLoadingTipos"
              @open="carregarTipos"
              @input="onTipoInput"
              :filterable="true"
              :searchable="true"
              :class="{ 'is-invalid': mostrarErros && erros.tipo }"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div v-if="mostrarErros && erros.tipo" class="text-danger mt-1 small">
              {{ erros.tipo }}
            </div>
            </div>
          </div>
        </div>
      </div>

    <!-- Card 2: Profissionais -->
    <div class="mt-4">
      <TabProfissionais
        :profissionais="profissionais"
        :getCboId="getCboId"
        :isEditMode="isEditMode"
        :erroResponsavel="erroResponsavel"
        @update:profissionais="onAtualizarProfissionais"
      />
    </div>

    <!-- Card 3: Local da atividade -->
    <div class="card card-topo mt-4">
      <div class="card-header bg-light font-weight-bold d-flex align-items-center">
        <i class="mdi mdi-map-marker mr-2"></i>
        Local da atividade
      </div>
      <div class="card-body">
        <div class="row">
          <!-- Campo CNES -->
          <div class="col-md-4 col-12 mb-3">
            <label for="cnes" class="form-label">Unidade Básica de Saúde</label>
            <vue-select
            id="cnes"
              v-model="cnesSelecionado"
              :options="estabelecimentos"
              label="label"
              placeholder="Busque por um CNES"
              :loading="isLoadingEst"
              @input="onCnesChange"
              @open="carregarEstabelecimentos"
              :filterable="true"
              :searchable="true"
              :class="{ 'is-invalid': mostrarErros && erros.cnes }"
            >
              <template slot="option" slot-scope="option">
                {{ option.nu_cnes }} - {{ option.no_unidade_saude }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div v-if="mostrarErros && erros.cnes" class="text-danger mt-1 small">
              {{ erros.cnes }}
            </div>
          </div>

          <!-- Campo INEP (dropdown semelhante ao CNES) -->
          <div class="col-md-4 col-12 mb-3">
            <label for="inep" class="form-label">Escola</label>
            <vue-select
            id="inep"
              v-model="inepSelecionado"
              :options="escolas"
              label="label"
              placeholder="Busque por uma escola (INEP)"
              :loading="isLoadingInep"
              @input="onInepChange"
              @open="carregarEscolas"
              :filterable="true"
              :searchable="true"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div v-if="mostrarErros && erros.inep" class="text-danger mt-1 small">
              {{ erros.inep }}
            </div>
          </div>

          <!-- Campo Outro -->
          <div class="col-md-4 col-12 mb-3">
            <label for="outraLocalidade" class="form-label">Outro</label>
          <input
            id="outraLocalidade"
            type="text"
            class="form-control"
            v-model="formData.outraLocalidade"
              placeholder="Informe o local da atividade"
              @input="atualizarLocalAtividade"
          />
            <div v-if="mostrarErros && erros.outraLocalidade" class="text-danger mt-1 small">
              {{ erros.outraLocalidade }}
            </div>
          </div>
        </div>

        <!-- Programa Saúde na Escola (quando INEP preenchido) - Oculto por enquanto -->
        <div class="row mb-3" v-if="false && formData.inep">
          <div class="col-md-12">
            <label class="form-label">Programa Saúde na Escola</label>
            <div>
              <div class="form-check form-check-inline">
                <input
                  type="checkbox"
                  id="programaEducacao"
                  v-model="formData.programaEducacao"
                  class="form-check-input"
                />
                <label for="programaEducacao" class="form-check-label">Educação</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="checkbox"
                  id="programaSaude"
                  v-model="formData.programaSaude"
                  class="form-check-input"
                />
                <label for="programaSaude" class="form-check-label">Saúde</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal para Guia de Oficina -->
    <b-modal
      v-model="modalGuiaShow"
      hide-footer
      centered
      scrollable
      size="xl"
      id="modal-guia-oficina"
      body-class="p-0"
      header-class="border-0 pb-0"
    >
      <template #modal-header>
        <div class="d-flex justify-content-between w-100 align-items-center px-3 pt-3">
          <h5 class="mb-0 font-weight-bold">Guia de Oficina de Monitoramento e Avaliação</h5>
          <button
            type="button"
            class="close"
            @click="modalGuiaShow = false"
            aria-label="Fechar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
      <div class="modal-guia-content">
        <OficinaSettingsScreen
          :config="oficinaConfig"
          @start-presentation="handleStartOficinaPresentation"
          @update-config="updateOficinaConfig"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { api } from '@/plugins/axios.js';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import TabProfissionais from './TabProfissionais.vue';
import OficinaSettingsScreen from '@/pages/OficinaMonitoramenteAvaliacao/components/SettingsScreen.vue';

export default {
  components: {
    'vue-select': VueSelect,
    TabProfissionais,
    OficinaSettingsScreen,
  },
  props: {
    formData: {
      type: Object,
      required: true,
      // Exemplo de valor padrão: { data: '', numeroParticipantes: 1, turno: null, localAtividade: '', cnes: '', inep: '', outraLocalidade: '' }
    },
    participantes: {
      type: Array,
      default: () => [],
    },
    profissionais: {
      type: Array,
      default: () => [],
    },
    getCboId: {
      type: Function,
      default: null,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    erroResponsavel: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      mostrarErros: false, // Controla a exibição dos erros
      dataFormatada: "",
      erros: {
        data: null,
        turno: null,
        numParticipantes: null,
        cnes: null,
        inep: null,
        outraLocalidade: null,
        horaInicio: null,
        horaFim: null,
        forma: null,
        tipo: null,
      },
      // Dados para o dropdown de estabelecimentos (CNES)
      isLoadingEst: false,
      estabelecimentos: [],
      cnesSelecionado: null,
      carregandoEstabelecimentos: false, // Flag para evitar chamadas simultâneas
      // Dados para o dropdown de INEP (escolas)
      isLoadingInep: false,
      escolas: [],
      inepSelecionado: null,
      // Dados para o dropdown de Tipos
      isLoadingTipos: false,
      tiposDisponiveis: [],
      tipoSelecionado: null,
      // Modal do Guia de Oficina
      modalGuiaShow: false,
      oficinaConfig: {
        state: '',
        city: '',
        facilitatorName: '',
        facilitatorPhoto: 'https://i.ibb.co/Jj9vpSkg/avatar-esus-1-X1.jpg',
        facilitatorBio: 'Especialista em Saúde Pública com foco em Monitoramento e Avaliação.',
        contactName: '',
        theme: 'Oficina de Monitoramento e Avaliação',
        whatsappNumber: '5583996801291',
        evaluationLink: 'https://esusfeedback.com.br/avaliacao-treinamento',
        platform: 'Google Meet',
        sosLink: 'https://sos.splashtop.com',
      },
    };
  },
  computed: {
    turnoFormatado() {
      const mapaTurno = {
        1: "Manhã",
        2: "Tarde",
        3: "Noite",
      };
      return mapaTurno[this.formData.turno] || "";
    },
    // Exemplo de computed para obter o cod_ibge (pode vir do store ou de outro lugar)
    codIbge() {
      return this.$store.state.cod_ibge || "2512606";
    },
    mostrarGuia() {
      const idFuncao = this.$store.state.id_funcao
      const funcao = this.$store.state.funcao
      return String(idFuncao) === '2' && funcao === 'Suporte eSUS Feedback'
    },
  },
  watch: {
    tipoSelecionado(newTipo, oldTipo) {
      if (newTipo) {
        // Usa o id do tipo (pode ser número ou string)
        const tipoId = newTipo.id || newTipo.codigo || newTipo;
        this.formData.tipo = tipoId ? (typeof tipoId === 'number' ? tipoId : parseInt(tipoId)) : null;
        
        // Emite evento para o componente pai quando o tipo mudar
        this.$emit('tipo-mudou', newTipo);
      } else {
        this.formData.tipo = null;
        this.$emit('tipo-mudou', null);
      }
    },
  },
  methods: {
    onTipoInput(valor) {
      // Atualiza o tipoSelecionado para garantir que o watch também dispare
      this.tipoSelecionado = valor;
      
      // Força a atualização do formData e emite o evento
      if (valor) {
        const tipoId = valor.id || valor.codigo || valor;
        this.formData.tipo = tipoId ? (typeof tipoId === 'number' ? tipoId : parseInt(tipoId)) : null;
        this.$emit('tipo-mudou', valor);
      } else {
        this.formData.tipo = null;
        this.$emit('tipo-mudou', null);
      }
      
      // Valida o tipo quando mudar
      if (this.mostrarErros) {
        this.validarTipo();
      }
    },
    abrirDatePicker() {
      // Abre o date picker nativo ao clicar no ícone
      this.$refs.datePicker.showPicker?.() || this.$refs.datePicker.click();
    },
    onDatePickerChange(event) {
      // Quando o date picker nativo muda, atualiza a data formatada
      const dataValue = event.target.value;
      if (dataValue) {
        const partes = dataValue.split('-');
        if (partes.length === 3) {
          this.dataFormatada = `${partes[2]}/${partes[1]}/${partes[0]}`;
          this.formData.data = dataValue;
          this.erros.data = null;
        }
      }
    },
    formatarData(event) {
      let valor = event.target.value.replace(/\D/g, '');
      if (valor.length >= 2) {
        valor = valor.substring(0, 2) + '/' + valor.substring(2);
      }
      if (valor.length >= 5) {
        valor = valor.substring(0, 5) + '/' + valor.substring(5, 9);
      }
      this.dataFormatada = valor;
      
      // Converte para formato YYYY-MM-DD para o v-model
      if (valor.length === 10) {
        const partes = valor.split('/');
        if (partes.length === 3) {
          this.formData.data = `${partes[2]}-${partes[1]}-${partes[0]}`;
        }
      }
    },
    toggleProgramaSaudeEscola(event) {
      // INEP desabilitado por enquanto - checkbox mantido para uso futuro
      // if (event.target.checked) {
      //   this.formData.localAtividade = 'escola';
      // }
    },
    atualizarLocalAtividade() {
      // Atualiza o localAtividade baseado nos campos preenchidos
      // Validação de campos mutuamente exclusivos: apenas um deve estar preenchido
      // Limpa outros campos quando um é preenchido (validação de exclusividade)
      if (this.formData.cnes && this.formData.cnes.trim() !== "") {
        this.formData.localAtividade = 'unidade';
        // Limpa outros campos se CNES foi preenchido
        if (this.formData.outraLocalidade) {
          this.formData.outraLocalidade = "";
        }
        if (this.formData.inep) {
          this.formData.inep = "";
          this.inepSelecionado = null;
        }
      } else if (this.formData.outraLocalidade && this.formData.outraLocalidade.trim() !== "") {
        this.formData.localAtividade = 'outro';
        // Limpa outros campos se Outra Localidade foi preenchida
        if (this.formData.cnes) {
          this.formData.cnes = "";
          this.cnesSelecionado = null;
        }
        if (this.formData.inep) {
          this.formData.inep = "";
          this.inepSelecionado = null;
        }
      } else if (this.formData.inep && this.formData.inep.trim() !== "") {
        this.formData.localAtividade = 'escola';
        // Limpa outros campos se INEP foi preenchido
        if (this.formData.cnes) {
          this.formData.cnes = "";
          this.cnesSelecionado = null;
        }
        if (this.formData.outraLocalidade) {
          this.formData.outraLocalidade = "";
        }
      } else {
        // Se nenhum campo está preenchido, limpa localAtividade
        this.formData.localAtividade = "";
      }
      
      // Revalida após atualizar
      if (this.mostrarErros) {
        this.validarCampoAdicional();
      }
    },
    validar() {
      this.mostrarErros = true; // Ativa a exibição dos erros
      this.validarData();
      this.validarTurno();
      this.validarNumParticipantes();
      this.validarHoras();
      this.validarForma();
      this.validarTipo();
      this.validarCampoAdicional();
      return (
        !this.erros.data &&
        !this.erros.turno &&
        !this.erros.numParticipantes &&
        !this.erros.cnes &&
        !this.erros.inep &&
        !this.erros.outraLocalidade &&
        !this.erros.horaInicio &&
        !this.erros.horaFim &&
        !this.erros.forma &&
        !this.erros.tipo
      );
    },
    validarCampoAdicional() {
      // Validação de campos mutuamente exclusivos conforme documentação FAC:
      // - cnesLocalAtividade: Preencher apenas se outraLocalidade e inep estiverem vazios
      // - outraLocalidade: Preencher apenas se inep e cnesLocalAtividade estiverem vazios
      // - inep: Preencher apenas se outraLocalidade e cnesLocalAtividade estiverem vazios
      
      const temCnes = this.formData.cnes && this.formData.cnes.trim() !== "";
      const temInep = this.formData.inep && this.formData.inep.trim() !== "";
      const temOutraLocalidade = this.formData.outraLocalidade && this.formData.outraLocalidade.trim() !== "";
      
      // Conta quantos campos estão preenchidos
      const camposPreenchidos = [temCnes, temInep, temOutraLocalidade].filter(Boolean).length;
      
      // Validação: apenas um campo deve estar preenchido
      if (camposPreenchidos > 1) {
        if (temCnes) {
          this.erros.cnes = "Preencha apenas um campo: CNES, INEP ou Outra Localidade.";
        }
        if (temInep) {
          this.erros.inep = "Preencha apenas um campo: CNES, INEP ou Outra Localidade.";
        }
        if (temOutraLocalidade) {
          this.erros.outraLocalidade = "Preencha apenas um campo: CNES, INEP ou Outra Localidade.";
        }
        return;
      }
      
      // Limpa erros se apenas um campo estiver preenchido ou nenhum
        this.erros.cnes = null;
      this.erros.inep = null;
      this.erros.outraLocalidade = null;
      
      // CNES é sempre obrigatório
      if (!this.formData.cnes || !this.cnesSelecionado) {
        this.erros.cnes = "O campo Unidade Básica de Saúde (CNES) é obrigatório.";
      }
      
      // Validações específicas por tipo de local (mantidas para outros campos)
      // INEP
      if (this.formData.localAtividade === "escola" && !this.formData.inep) {
        this.erros.inep = "O campo INEP é obrigatório.";
      } else {
        this.erros.inep = null;
      }
      
      if (this.formData.localAtividade === "outro") {
        if (!this.formData.outraLocalidade) {
          this.erros.outraLocalidade = "O campo Outra Localidade é obrigatório quando selecionado 'Outro'.";
        }
      }
    },
    corrigirNumeroParticipantes(event) {
      let valor = parseInt(event.target.value, 10);
      const valorMinimo = this.isEditMode ? 0 : 1;

      if (isNaN(valor) || valor < valorMinimo) {
        valor = valorMinimo; // Valor mínimo (0 em edição, 1 em criação)
      } else if (valor > 999) {
        valor = 999; // Valor máximo
      }

      this.formData.numeroParticipantes = valor;
    },
    validarData() {
      if (!this.formData.data && !this.dataFormatada) {
        this.erros.data = "A data é obrigatória.";
      } else if (this.dataFormatada && this.dataFormatada.length !== 10) {
        this.erros.data = "Data inválida. Use o formato dd/mm/aaaa.";
      } else {
        this.erros.data = null;
      }
    },
    validarTurno() {
      if (!this.formData.turno) {
        this.erros.turno = "O turno é obrigatório.";
      } else {
        this.erros.turno = null;
      }
    },
    validarNumParticipantes() {
      const numeroParticipantes = this.formData.numeroParticipantes;
      const participantesInseridos = this.participantes.length;
      const valorMinimo = this.isEditMode ? 0 : 1;
      const mensagemMinimo = this.isEditMode ? "0 e 999" : "1 e 999";

      if (numeroParticipantes < valorMinimo || numeroParticipantes > 999) {
        this.erros.numParticipantes =
          `Número de participantes deve estar entre ${mensagemMinimo}.`;
      } else if (numeroParticipantes < participantesInseridos) {
        this.erros.numParticipantes = `Número de participantes não pode ser menor que o total de ${participantesInseridos} participantes inseridos.`;
      } else {
        this.erros.numParticipantes = null;
      }
    },
    validarHoras() {
      if (!this.formData) return;
      
      const horaInicio = this.formData.horaInicio;
      const horaFim = this.formData.horaFim;

      // Limpa erros anteriores
      if (this.erros) {
        this.erros.horaInicio = null;
        this.erros.horaFim = null;
      }

      // Validação obrigatória
      if (!horaInicio) {
        this.erros.horaInicio = "A hora de início é obrigatória.";
      }
      
      if (!horaFim) {
        this.erros.horaFim = "A hora de fim é obrigatória.";
      }

      // Se alguma hora estiver vazia, não valida a lógica de comparação
      if (!horaInicio || !horaFim) {
        return;
      }

      // Converte as horas para minutos para facilitar a comparação
      const [horaInicioH, minutoInicioM] = horaInicio.split(':').map(Number);
      const [horaFimH, minutoFimM] = horaFim.split(':').map(Number);
      
      const minutosInicio = horaInicioH * 60 + minutoInicioM;
      const minutosFim = horaFimH * 60 + minutoFimM;

      // Valida se hora de início é maior ou igual à hora de fim
      if (minutosInicio >= minutosFim) {
        if (this.erros) {
          this.erros.horaInicio = "A hora de início deve ser menor que a hora de fim.";
          this.erros.horaFim = "A hora de fim deve ser maior que a hora de início.";
        }
        return;
      }

      // Calcula a carga horária automaticamente
      const diferencaMinutos = minutosFim - minutosInicio;
      const horasCalculadas = Math.round(diferencaMinutos / 60);
      
      // Limita entre 1 e 8 horas (se calcular mais de 8, seta em 8 que é o máximo)
      const qtdHorasFinal = Number(Math.max(1, Math.min(8, horasCalculadas)));
      
      // Atualiza o campo de carga horária
      this.formData.qtdHoras = qtdHorasFinal;
    },
    validarForma() {
      if (!this.formData.forma) {
        this.erros.forma = "A forma é obrigatória.";
      } else {
        this.erros.forma = null;
      }
    },
    validarTipo() {
      if (!this.formData.tipo && !this.tipoSelecionado) {
        this.erros.tipo = "O tipo é obrigatório.";
      } else {
        this.erros.tipo = null;
      }
    },
    onAtualizarProfissionais(lista) {
      // Propaga atualização para o componente pai
      this.$emit('update:profissionais', lista);
    },
    async carregarEstabelecimentos() {
      if (this.carregandoEstabelecimentos) {
        return new Promise((resolve) => {
          const checkInterval = setInterval(() => {
            if (!this.carregandoEstabelecimentos) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
        });
      }
      
      if (this.estabelecimentos.length > 0) {
        return Promise.resolve();
      }
      
      this.carregandoEstabelecimentos = true;
      this.isLoadingEst = true;
      try {
        const response = await api.get(`/app/profissionais-lotacoes/${this.codIbge}/1`);
        const profissionais = Array.isArray(response.data) ? response.data : [];
        
        const estabelecimentosMap = new Map();
        
        profissionais.forEach(prof => {
          let lotacoes = [];
          if (prof.lotacoes) {
          try {
              lotacoes = JSON.parse(prof.lotacoes);
          } catch (e) {
            }
          }
          
          if (Array.isArray(lotacoes) && lotacoes.length > 0) {
            lotacoes.forEach(lotacao => {
              if (lotacao.nu_cnes && lotacao.no_unidade_saude) {
                const cnes = lotacao.nu_cnes;
                if (!estabelecimentosMap.has(cnes)) {
                  estabelecimentosMap.set(cnes, {
                    nu_cnes: cnes,
                    no_unidade_saude: lotacao.no_unidade_saude,
                    label: `${cnes} - ${lotacao.no_unidade_saude}`
                  });
                }
              }
            });
          }
        });
        
        this.estabelecimentos = Array.from(estabelecimentosMap.values());
      } catch (error) {
        this.estabelecimentos = [];
      } finally {
      this.isLoadingEst = false;
        this.carregandoEstabelecimentos = false;
      }
    },
    onCnesChange(estabelecimento) {
      if (estabelecimento) {
        this.formData.cnes = estabelecimento.nu_cnes;
        // Limpa erro ao selecionar CNES
        if (this.erros.cnes) {
          this.erros.cnes = null;
        }
        this.formData.localAtividade = 'unidade';
        // Limpa outros campos mutuamente exclusivos
        if (this.formData.outraLocalidade) {
          this.formData.outraLocalidade = "";
        }
        if (this.formData.inep) {
          this.formData.inep = "";
          this.inepSelecionado = null;
        }
        this.atualizarLocalAtividade();
        // Valida o campo após selecionar
        if (this.mostrarErros) {
          this.validarCampoAdicional();
        }
      } else {
        this.formData.cnes = "";
        this.cnesSelecionado = null;
        this.formData.localAtividade = "";
        this.atualizarLocalAtividade();
        // Valida o campo após limpar
        if (this.mostrarErros) {
          this.validarCampoAdicional();
        }
      }
    },
    async carregarEscolas() {
      if (this.escolas.length > 0) {
        return Promise.resolve(); // Já carregado
      }

      this.isLoadingInep = true;
      try {
        // Por enquanto, mostra apenas "Sem informação"
        this.escolas = [
          {
            nu_inep: null,
            no_escola: "Sem informação",
            label: "Sem informação",
          },
        ];
      } catch (error) {
        this.escolas = [
          {
            nu_inep: null,
            no_escola: "Sem informação",
            label: "Sem informação",
          },
        ];
      } finally {
        this.isLoadingInep = false;
      }
    },
    async carregarTipos() {
      if (this.tiposDisponiveis.length > 0) {
        return Promise.resolve(); // Já carregado
      }
      
      this.isLoadingTipos = true;
      try {
        const response = await api.get('/app/oficinas-treinamentos/tipos');
        this.tiposDisponiveis = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        this.tiposDisponiveis = [];
      } finally {
        this.isLoadingTipos = false;
      }
    },
    onInepChange(escola) {
      // Se for "Sem informação" ou não tiver nu_inep, não envia o INEP
      if (escola && escola.nu_inep && escola.label !== "Sem informação") {
        this.formData.inep = escola.nu_inep;
        this.formData.localAtividade = "escola";
        // Limpa outros campos mutuamente exclusivos
        if (this.formData.cnes) {
          this.formData.cnes = "";
          this.cnesSelecionado = null;
        }
        if (this.formData.outraLocalidade) {
          this.formData.outraLocalidade = "";
        }
      } else {
        // Não envia INEP se for "Sem informação" ou vazio
        this.formData.inep = "";
        if (this.formData.localAtividade === "escola") {
          this.formData.localAtividade = "";
        }
      }
      this.atualizarLocalAtividade();
    },
    async sincronizarCnesDoResponsavel() {
      // Só preenche automaticamente se ainda não tiver CNES definido
      if (this.formData.cnes || !Array.isArray(this.profissionais) || this.profissionais.length === 0) {
        return;
      }

      const responsavel = this.profissionais[0];
      const cnesResponsavel = responsavel?.nu_cnes || responsavel?.nuCnes;

      if (!cnesResponsavel) {
        return;
      }

      // Define o CNES no form e marca local como unidade
      this.formData.cnes = cnesResponsavel;
      this.formData.localAtividade = 'unidade';

      // Carrega estabelecimentos e seleciona o correspondente no dropdown
      await this.carregarEstabelecimentos();
      let estabelecimento = this.estabelecimentos.find(
        (est) => est.nu_cnes === cnesResponsavel
      );
      if (estabelecimento) {
        this.cnesSelecionado = estabelecimento;
      } else {
        // Se a API ainda não retornou esse CNES específico,
        // cria uma opção mínima apenas com o código para exibição.
        estabelecimento = {
          nu_cnes: cnesResponsavel,
          no_unidade_saude: '',
          label: `${cnesResponsavel}`,
        };
        this.estabelecimentos.push(estabelecimento);
        this.cnesSelecionado = estabelecimento;
      }

      this.atualizarLocalAtividade();
    },
    abrirGuia() {
      // Verificar se o tipo foi selecionado
      if (!this.tipoSelecionado || !this.tipoSelecionado.tp_reun_ofic_treinam) {
        this.$toast.error(
          'Por favor, selecione o tipo da Atividade antes de abrir o guia.',
          'Tipo não selecionado',
          {
            position: 'topRight',
            timeout: 5000,
          }
        )
        return
      }

      // Pega estado e cidade da store
      const cidadeEstado = this.$store.state.cidade || '';
      let estado = '';
      let cidade = '';

      if (cidadeEstado && cidadeEstado.includes(' - ')) {
        const partes = cidadeEstado.split(' - ');
        cidade = partes[0]?.trim() || '';
        estado = partes[1]?.trim() || '';
      }

      // Usa o tipo selecionado como tema
      const temaTipo = this.tipoSelecionado.tp_reun_ofic_treinam || 'Oficina de Monitoramento e Avaliação'

      // Montar configuração básica da oficina com dados do usuário logado
      this.oficinaConfig = {
        state: estado || '',
        city: cidade || '',
        facilitatorName: this.$store.state.username || '',
        facilitatorPhoto: this.$store.state.fotoPerfil
          ? `https://esusfeedback.com.br/api/uploads/usuarios/${this.$store.state.fotoPerfil}`
          : 'https://i.ibb.co/Jj9vpSkg/avatar-esus-1-X1.jpg',
        facilitatorBio: 'Especialista em Saúde Pública com foco em Monitoramento e Avaliação.',
        contactName: '',
        theme: temaTipo,
        whatsappNumber: '5583996801291',
        evaluationLink: 'https://esusfeedback.com.br/avaliacao-treinamento',
        platform: 'Google Meet',
        sosLink: 'https://sos.splashtop.com',
      }

      // Abrir diretamente a apresentação em nova aba, usando a mesma lógica do SettingsScreen
      const params = new URLSearchParams({
        state: this.oficinaConfig.state,
        city: this.oficinaConfig.city,
        facilitatorName: this.oficinaConfig.facilitatorName,
        facilitatorPhoto: this.oficinaConfig.facilitatorPhoto,
        contactName: this.oficinaConfig.contactName,
        theme: this.oficinaConfig.theme,
        whatsappNumber: this.oficinaConfig.whatsappNumber,
        evaluationLink: this.oficinaConfig.evaluationLink,
        platform: this.oficinaConfig.platform,
        sosLink: this.oficinaConfig.sosLink,
      })

      // Abre na tela de configurações da oficina; de lá o usuário clica em "Iniciar Apresentação"
      const configuracaoUrl = `${window.location.origin}/oficina-monitoramento-avaliacao?${params.toString()}`
      window.open(configuracaoUrl, '_blank')
    },
    handleStartOficinaPresentation() {
      // Quando iniciar apresentação, fechar modal e abrir em nova janela
      this.modalGuiaShow = false
      
      // Construir query params
      const params = new URLSearchParams({
        state: this.oficinaConfig.state,
        city: this.oficinaConfig.city,
        facilitatorName: this.oficinaConfig.facilitatorName,
        facilitatorPhoto: this.oficinaConfig.facilitatorPhoto,
        contactName: this.oficinaConfig.contactName,
        theme: this.oficinaConfig.theme,
        whatsappNumber: this.oficinaConfig.whatsappNumber,
        evaluationLink: this.oficinaConfig.evaluationLink,
        platform: this.oficinaConfig.platform,
        sosLink: this.oficinaConfig.sosLink,
      })
      
      // Abrir em nova janela
      const apresentacaoUrl = `${window.location.origin}/oficina-monitoramento-avaliacao/apresentacao?${params.toString()}`
      window.open(apresentacaoUrl, '_blank')
    },
    updateOficinaConfig(newConfig) {
      this.oficinaConfig = { ...this.oficinaConfig, ...newConfig }
    },
  },
  watch: {
    participantes: {
      handler() {
        this.validarNumParticipantes();
      },
      immediate: true,
    },
    'formData.data': {
      handler(newValue) {
        if (newValue && !this.dataFormatada) {
          // Converte de YYYY-MM-DD para dd/mm/aaaa
          const partes = newValue.split('-');
          if (partes.length === 3) {
            this.dataFormatada = `${partes[2]}/${partes[1]}/${partes[0]}`;
          }
        }
      },
      immediate: true,
    },
    profissionais: {
      handler(newVal, oldVal) {
        if (oldVal && oldVal.length > 0 && !this.formData.cnes) {
          this.sincronizarCnesDoResponsavel();
        }
      },
      immediate: false,
      deep: true,
    },
  },
  async mounted() {
    if (this.formData.data) {
      const partes = this.formData.data.split('-');
      if (partes.length === 3) {
        this.dataFormatada = `${partes[2]}/${partes[1]}/${partes[0]}`;
      }
    } else {
      // Nova ficha → fixa a data de hoje
      const hoje = new Date();
      const ano = hoje.getFullYear();
      const mes = String(hoje.getMonth() + 1).padStart(2, '0');
      const dia = String(hoje.getDate()).padStart(2, '0');
      this.formData.data = `${ano}-${mes}-${dia}`;
      this.dataFormatada = `${dia}/${mes}/${ano}`;
    }
    
    if (this.formData.cnes) {
      await this.carregarEstabelecimentos();
      const estabelecimento = this.estabelecimentos.find(
        (est) => est.nu_cnes === this.formData.cnes
      );
      if (estabelecimento) {
        this.cnesSelecionado = estabelecimento;
      }
    }
    
    // Sincroniza o tipo selecionado se já houver valor
    if (this.formData.tipo) {
      await this.carregarTipos();
      const tipo = this.tiposDisponiveis.find(
        (t) => t.id === this.formData.tipo
      );
      if (tipo) {
        this.tipoSelecionado = tipo;
      }
    }
  },
};
</script>

<style>
@import '../../OficinaMonitoramenteAvaliacao/styles.css';
</style>

<style scoped>
.modal-guia-content {
  min-height: 500px;
  max-height: 85vh;
  overflow-y: auto;
  padding: 0;
}

/* Ajustar estilos da oficina dentro do modal */
.modal-guia-content :deep(.oficina-settings-screen) {
  padding: 0;
  min-height: auto;
  align-items: flex-start;
}

.modal-guia-content :deep(.oficina-settings-container) {
  max-width: 100%;
  width: 100%;
  margin: 0;
  padding: 24px;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
}

.modal-guia-content :deep(.oficina-settings-header) {
  margin-bottom: 24px;
}

.modal-guia-content :deep(.oficina-settings-header h1) {
  font-size: 24px;
}

.modal-guia-content :deep(.oficina-settings-header i) {
  font-size: 40px;
  margin-bottom: 12px;
}

.modal-guia-content :deep(.oficina-settings-form) {
  gap: 20px;
}

.modal-guia-content :deep(.oficina-form-group) {
  gap: 6px;
}

.modal-guia-content :deep(.oficina-form-group label) {
  font-size: 13px;
}

.modal-guia-content :deep(.oficina-input),
.modal-guia-content :deep(.oficina-textarea) {
  padding: 10px 14px;
  font-size: 14px;
}

.modal-guia-content :deep(.oficina-platform-btn) {
  padding: 14px;
  font-size: 14px;
}

.modal-guia-content :deep(.oficina-btn-primary) {
  padding: 12px 24px;
  font-size: 15px;
  margin-top: 4px;
}

.card-topo {
  padding: 0px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.card-header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 16px;
  font-size: 1rem;
}

.card-header .btn {
  white-space: nowrap;
  font-size: 0.875rem;
  padding: 6px 12px;
}

/* Botão Guia com cor azul primária */
.card-header .btn-primary {
  background-color: #0fafd7 !important;
  border-color: #0fafd7 !important;
  color: #fff !important;
}

.card-header .btn-primary:hover {
  background-color: #0d98bb !important;
  border-color: #0d98bb !important;
  color: #fff !important;
}

.card-body {
  padding: 20px;
}

.form-label {
  font-weight: 500;
  color: #333;
  margin-bottom: 6px;
  font-size: 0.9rem;
}

.form-label.required::after {
  content: " *";
  color: #dc3545;
}

.form-control,
.form-select {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 0.9rem;
  height: 38px;
}

.form-select.form-control {
  height: 38px;
  padding: 8px 12px;
}

.form-control:focus,
.form-select:focus {
  border-color: #0fafd7;
  box-shadow: 0 0 0 0.2rem rgba(15, 175, 215, 0.25);
}

.input-group .form-control {
  height: 38px;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  background-color: #e9ecef;
}

.input-date-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-with-icon {
  padding-right: 40px;
}

.date-picker-hidden {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.date-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
  font-size: 1.2rem;
  z-index: 10;
  pointer-events: auto;
  transition: color 0.2s ease;
}

.date-icon:hover {
  color: #0fafd7;
}


.text-danger {
  color: #dc3545;
  font-size: 0.8rem;
}

.small {
  font-size: 0.8rem;
}

.form-check {
  margin-top: 0;
}

.form-check-label {
  font-weight: normal;
  margin-left: 5px;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

::v-deep .is-invalid .vs__dropdown-toggle {
  border-color: #dc3545;
}

::v-deep .is-invalid .vs__dropdown-toggle:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

/* Esconde opções disabled no dropdown */
select option[disabled] {
  display: none;
}

/* Mostra a opção disabled apenas quando é a selecionada (placeholder) */
select option[disabled][selected] {
  display: block;
  color: #6c757d;
}
</style>
